var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "form",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("transition", { attrs: { name: "trs-simple-fade", mode: "out-in" } }, [
        _vm.wasSent
          ? _c("div", { key: "success" }, [_vm._t("success")], 2)
          : _c(
              "div",
              { key: "main" },
              [
                _vm.genericErrorMessage
                  ? _c("p", { staticClass: "ajax-form--error" }, [
                      _vm._v(_vm._s(_vm.genericErrorMessage))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("main", null, {
                  isLoading: _vm.isLoading,
                  getFieldMessagesByName: _vm.getFieldMessagesByName,
                  onSubmit: _vm.onSubmit
                })
              ],
              2
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71dd50f0", { render: render, staticRenderFns: staticRenderFns })
  }
}